import { StoreAction, XmAction } from 'store/actions';
import { Logger } from './models';

export function loggerReducer(state: Logger, action: XmAction<Logger>): Logger {
    switch (action.type) {
        case StoreAction.POST_LOGGER:
            return action.payload;
        default:
            return state;
    }
}
